<kendo-dialog-titlebar (close)="fecheModal()">
  <h4 class="modal-title" id="myModalLabel">
    {{sistemaExterno ? 'Importar de Sistema Externo' : 'Importar do Catálogo do ' + obtenhaNomeFonteImportacao()}}
  </h4>
</kendo-dialog-titlebar>

<div #pnl class="modal-body">

  <form [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
        novalidate #frm="ngForm" (ngSubmit)="onBusqueProdutos()"
        *ngIf="buscarProdutos">

    <!-- iFood Oficial -->
    <ng-container *ngIf="ifoodOficial">
      <div class="form-group mb-3">
        <label for="integracaoIfood" class="secao-label">Selecione a Loja</label>
        <kendo-dropdownlist
          id="integracaoIfood" name="idLojaIfood" class="form-control"
          [data]="integracoesIfood" textField="nomeLoja" valueField="idLoja"
          [valuePrimitive]="true" [(ngModel)]="opcoes.idLojaIfood" #idLojaIfood="ngModel"
          (valueChange)="onMudouIntegracaoIfood()"
          [defaultItem]="{idLoja: null, nomeLoja: 'Selecione uma integração'}" required>
        </kendo-dropdownlist>
        <div class="invalid-feedback">
          <p *ngIf="idLojaIfood.errors?.required">Integração é obrigatória</p>
        </div>
      </div>

      <div class="form-group mb-3">
      <label for="catalogoIfood" class="secao-label">Catálogo para importar</label>
        <kendo-dropdownlist
          id="catalogoIfood" name="idCatalogoIfood" class="form-control"
          [data]="catalogosIfood" textField="descricao" valueField="id"
          [valuePrimitive]="true" [(ngModel)]="opcoes.idCatalogoIfood" #idCatalogoIfood="ngModel"
          [defaultItem]="{id: null, descricao: 'Selecione um catálogo'}"
          [disabled]="!opcoes.idLojaIfood || carregandoCatalogos" required>
        </kendo-dropdownlist>
        <small class="form-text text-muted" *ngIf="carregandoCatalogos">Carregando catálogos oficiais...</small>
        <div class="invalid-feedback">
          <p *ngIf="idCatalogoIfood.errors?.required">Catálogo para importar é obrigatório</p>
        </div>
      </div>
    </ng-container>

    <!-- Sistema Externo -->
    <ng-container *ngIf="sistemaExterno">
      <p class="secao-label">Selecione a plataforma</p>
      <div class="plataformas-selecao mb-3" [class.shake]="shakePlataforma">
        <div class="plat-card"
             *ngFor="let p of PLATAFORMAS"
             [class.ativa]="plataformaSelecionada?.id === p.id"
             (click)="selecionePlataforma(p)">
          <img [src]="p.logo" [alt]="p.nome" [ngClass]="{'plat-logo': true, 'plat-logo-lg': p.id === 'instadelivery'}">
          <span>{{ p.nome }}</span>
        </div>
      </div>

      <!-- Secao iFood -->
      <div class="divisor-texto">
        <span>Não usa nenhum dos sistemas acima?</span>
      </div>
      <div class="plat-card plat-card-ifood" [class.shake]="shakePlataforma"
           [class.ativa]="plataformaSelecionada?.id === 'ifood'"
           (click)="selecionePlataforma(PLATAFORMA_IFOOD)">
        <img [src]="PLATAFORMA_IFOOD.logo" [alt]="PLATAFORMA_IFOOD.nome" class="plat-logo">
        <div class="plat-ifood-info">
          <span>Importar do {{ PLATAFORMA_IFOOD.nome }}</span>
          <small>Importa produtos diretamente do link do iFood</small>
        </div>
      </div>

      <div class="divisor"></div>

      <div class="form-group mb-3" [class.shake]="shakeLink" [class.shake-border]="shakeLink">
        <label class="secao-label">Link da sua loja</label>
        <div class="link-input-prefixo">
          <div class="link-prefixo" *ngIf="plataformaSelecionada && plataformaSelecionada.prefixo">
            <img [src]="plataformaSelecionada.logo" class="link-prefixo-logo">
            <span>{{ plataformaSelecionada.prefixo }}</span>
          </div>
          <input type="text" class="form-control" autocomplete="off"
                 name="link" [(ngModel)]="opcoes.link" #link="ngModel"
                 [placeholder]="plataformaSelecionada?.placeholder || 'Cole aqui o link do seu cardápio'"
                 appAutoFocus [autoFocus]="!!plataformaSelecionada"
                 (ngModelChange)="onUrlChanged()"
                 (paste)="onPasteLink($event)"
                 (keyup.enter)="validarEBuscar()">
          <div class="link-sufixo" *ngIf="plataformaSelecionada?.sufixo">
            <span>{{ plataformaSelecionada.sufixo }}</span>
          </div>
          <button type="button" class="btn-copiar-inline" *ngIf="opcoes.link && plataformaSelecionada"
                  (click)="copiarLink()" [class.copiado]="linkCopiado"
                  title="Copiar link completo">
            <i [class]="linkCopiado ? 'fe-check' : 'fe-copy'"></i>
          </button>
        </div>
        <div class="link-preview" *ngIf="opcoes.link && plataformaSelecionada">
          <i class="fe-link"></i> {{ obtenheLinkCompleto() }}
        </div>
        <div class="link-detectado" *ngIf="plataformaDetectada && plataformaDetectada.id !== plataformaSelecionada?.id">
          <img [src]="plataformaDetectada.logo" [alt]="plataformaDetectada.nome">
          Detectado: {{ plataformaDetectada.nome }}
        </div>
      </div>
      <p class="erro-validacao" *ngIf="erroValidacao">
        <i class="fe-alert-circle mr-1"></i> {{erroValidacao}}
      </p>
    </ng-container>

    <!-- Link padrão (modo específico) -->
    <div class="form-group mb-3" *ngIf="!ifoodOficial && !sistemaExterno">
      <label for="link" class="secao-label">Link para importação</label>
      <div class="link-input-wrapper">
        <input type="text" class="form-control" autocomplete="off"
               id="link" name="link" [(ngModel)]="opcoes.link" #link="ngModel"
               placeholder="Informe o link para importação"
               value="" required appAutoFocus [autoFocus]="true">
      </div>
      <div class="invalid-feedback">
        <p *ngIf="link.errors?.required">Link é obrigatório</p>
      </div>
    </div>

    <div class="divisor"></div>

    <!-- Opções -->
    <p class="secao-label">Opções</p>

    <div class="form-group mb-3">
      <label>Percentual redução (opcional)</label>
      <kendo-numerictextbox [attr.type]="'number'" class="form-control" [(ngModel)]="opcoes.reducao"
                            #reducao="ngModel" [min]="1" [max]="100" name="reducao" [format]="obtenhaFormatoPercentual()">
      </kendo-numerictextbox>
      <div class="invalid-feedback">
        <p *ngIf="reducao.errors">Valor do percentual tem ser 1 a 100</p>
      </div>
    </div>

    <div class="opcoes-grid">
      <div class="opcao-check">
        <input type="checkbox" id="sincronizarPrecos" name="sincronizarPrecos" class="k-checkbox" kendoCheckBox
               [(ngModel)]="opcoes.sincronizarPrecos"/>
        <label for="sincronizarPrecos">Importar preços</label>
      </div>
      <div class="opcao-check">
        <input type="checkbox" id="sincronizarImagens" name="sincronizarImagens" class="k-checkbox" kendoCheckBox
               [(ngModel)]="opcoes.sincronizarImagens"/>
        <label for="sincronizarImagens">Importar imagens</label>
      </div>
    </div>

    <!-- Mensagens -->
    <div class="alert alert-danger alert-dismissible fade show mt-3" role="alert" *ngIf="mensagemErro">
      <i class="mdi mdi-check-all mr-2"></i> {{mensagemErro}}
      <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" (click)="fecheMensagemErro()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="text-center mt-4" *ngIf="buscando">
      <div class="k-i-loading" style="font-size: 40px; height: 60px;"></div>
      <p class="mt-2" style="color: #64748b; font-size: 14px;">
        Buscando produtos para importar do {{obtenhaNomeFonteImportacao()}}...
      </p>
    </div>

    <div class="alert alert-info alert-dismissible fade show mt-3" *ngIf="buscouProdutos && tudoSincronizado" role="alert">
      <h6>Não há nenhum produto novo para importar do {{obtenhaNomeFonteImportacao()}}.</h6>
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

  </form>

  <!-- Info da empresa -->
  <div *ngIf="empresaInfo" class="empresa-info-card mt-3">
    <div class="empresa-info-header">
      <img *ngIf="empresaInfo.logo || empresaInfo.imagem" [src]="empresaInfo.logo || empresaInfo.imagem"
           class="empresa-info-logo" alt="Logo">
      <div>
        <h4 class="empresa-info-nome" *ngIf="empresaInfo.nome"><b>{{empresaInfo.nome}}</b></h4>
      </div>
    </div>
    <div class="empresa-info-dados">
      <p *ngIf="empresaInfo.endereco"><i class="fe-map-pin mr-1"></i> {{empresaInfo.endereco}}</p>
      <p *ngIf="empresaInfo.cep"><i class="fe-hash mr-1"></i> CEP {{empresaInfo.cep}}</p>
      <p *ngIf="empresaInfo.whatsapp || empresaInfo.telefone"><i class="fe-phone mr-1"></i> {{empresaInfo.whatsapp || empresaInfo.telefone}}</p>
      <p *ngIf="empresaInfo.latitudeLongitude"><i class="fe-navigation mr-1"></i> Localização detectada</p>
      <p *ngIf="empresaInfo.horarios?.length"><i class="fe-clock mr-1"></i> {{empresaInfo.horarios.length}} horário(s) de funcionamento</p>
    </div>
  </div>

  <!-- Status adicionais -->
  <div class="status-carregamento-adicionais mt-3" role="alert" *ngIf="usaFluxoIfoodAntigo() && carregandoAdicionais">
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <span class="k-icon k-i-loading mr-2"></span>
        <strong>Carregando adicionais dos produtos</strong>
      </div>
      <span>{{carregamentoAdicionais.totalProcessados}}/{{carregamentoAdicionais.totalProdutos}}</span>
    </div>
    <div class="mt-1 mb-1">página {{carregamentoAdicionais.paginaAtual}}/{{carregamentoAdicionais.totalPaginas}}</div>
    <div class="mt-1 mb-1" *ngIf="statusCarregamentoAdicionais">{{statusCarregamentoAdicionais}}</div>
    <div class="mt-2 mb-2">
      <button type="button" class="btn btn-sm btn-outline-primary" (click)="importarSemAdicionais()"
              [disabled]="pularAdicionais">
        Importar sem adicionais
      </button>
    </div>
    <div class="progress progress-adicionais">
      <div class="progress-bar progress-bar-striped progress-bar-animated"
           role="progressbar"
           [style.width.%]="obtenhaPercentualCarregamentoAdicionais()"
           [attr.aria-valuenow]="obtenhaPercentualCarregamentoAdicionais()"
           aria-valuemin="0" aria-valuemax="100">
        {{obtenhaPercentualCarregamentoAdicionais()}}%
      </div>
    </div>
  </div>

  <!-- Painel de produtos -->
  <app-painel-importacao-produtos #painelImportacao [hidden]="buscarProdutos"
                                  [bloquearSincronizacao]="carregandoAdicionais"
                                  (onImportou)="importouProdutoDoIfood($event)"></app-painel-importacao-produtos>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light waves-effect" data-dismiss="modal" (click)="feche()">{{painelImportacao && painelImportacao.importacao.finalizou ? 'Fechar' : 'Cancelar'}}</button>

  <button type="button" class="btn btn-primary waves-effect waves-light"
          [disabled]="buscando"
          *ngIf="buscarProdutos" (click)="validarEBuscar()">
    <i class="k-icon k-i-loading" *ngIf="buscando"></i>
    <i class="fe-search mr-1" *ngIf="!buscando"></i> Buscar produtos
  </button>

  <button class="btn btn-danger" *ngIf="!buscarProdutos" (click)="painelImportacao.sincronizeTodos()"
          [disabled]="(painelImportacao && painelImportacao.importacao.sincronizando) || carregandoAdicionais"
          [hidden]="painelImportacao && painelImportacao.importacao.finalizou">
    <i class="k-icon k-i-loading" *ngIf="painelImportacao && painelImportacao.importacao.sincronizando"></i>
    Importar todos
  </button>
</div>
